/**
 * Product Detail Page JS.
 *
 * 1. Stock 在庫：あり/なし — AJAX per-SKU /api/v1/stock (public, mirror Joomla
 *    getStockSearchSku Cnet). Out-of-stock → disable nút mua (cả 2 sidebar).
 * 2. 自由選択 (mix & match, F16b Approach B): port logic
 *    selected_product_addtocart_form.tpl.php (totalValue / addEachValue /
 *    minusEachValue / confirmValue / changeRemainedNum) — tổng = 選択可能数
 *    mới enable nút; submit POST /cart/add.js parent variant qty=1 +
 *    properties[_mix_match_breakdown] (Cart Transform Function expand).
 *
 * Qty stepper + add-to-cart normal: KHÔNG xử lý ở đây — contract cart-add.js
 * global ([data-ink-cart-item] + [data-qty-dec/val/inc] + [data-ink-add-cart],
 * rule .claude/rules/add-to-cart.md) — đồng nhất toppage/category.
 */
(function () {
  'use strict';

  const PROXY_BASE = ((window.INK_API_CONFIG && window.INK_API_CONFIG.proxyBase) || '/apps/ink').replace(/\/$/, '');
  const STOCK_URL = PROXY_BASE + '/api/v1/stock';

  /**
   * Token CHỈ dùng khi biết chắc nó thuộc customer đang login.
   *
   * File này chạy TRƯỚC `api-client.js` (nó load cuối `theme.liquid`, còn file này load
   * trong section) nên không thể dựa vào `window.inkApi`. `api-client` cố ý KHÔNG
   * xoá token có chủ khác khỏi localStorage (xoá là phá phiên tab đang sống),
   * nên đọc thô `localStorage.ink_api_token` có thể lấy token của customer khác: server
   * chặn bằng `SESSION_MISMATCH` nên không rò dữ liệu, nhưng request thành 401 và badge
   * 在庫/campaign mất im lặng. Vì vậy tự kiểm owner ở đây — cùng luật `api-client.js`.
   */
  function ownedToken() {
    const cfg = window.INK_API_CONFIG || {};
    const id = cfg.customer && cfg.customer.id;
    if (!id) return null; // guest → không gắn token nào

    if (window.inkApi && window.inkApi.token) return window.inkApi.token;

    const owner = (cfg.shopDomain || '') + '|' + id;
    if (localStorage.getItem('ink_api_token_owner') !== owner) return null;

    return localStorage.getItem('ink_api_token');
  }

  // Token (logged-in) → campaign present exclude FO/ASOSHI/PAN (giống collection.js).
  function authHeaders() {
    const token = ownedToken();
    const h = { Accept: 'application/json', 'ngrok-skip-browser-warning': '1' };
    if (token) h['X-Ink-Token'] = token;
    return h;
  }

  // ===== 1. Stock 在庫表示 + khu mua hàng =====
  // Rule js-code.md §Loading (giống 3.1b card): khu mua SSR = skeleton pulse +
  // control ẩn → stock về hiện control; out_of_stock → DISABLE nút mua (KHÔNG hiện
  // block text 在庫なし — text 在庫：なし phía trên đã đủ); API fail → fail-open
  // (guard thật = /stock/validate).
  // Trạng thái SSR 販売終了 (metafield custom.buy_disabled) — chốt 1 lần TRƯỚC khi
  // JS mutate DOM: notice render không-hidden = server nói đang đóng bán.
  let ssrBuyDisabledMemo = null;
  function ssrBuyDisabled() {
    if (ssrBuyDisabledMemo === null) {
      ssrBuyDisabledMemo = !!document.querySelector('[data-buy-disabled-notice]:not([hidden])');
    }
    return ssrBuyDisabledMemo;
  }

  function applyStockUI(main, state) {
    // API fail/unknown mà SSR đang 販売終了 → GIỮ trạng thái SSR (metafield là
    // thông tin tốt nhất đang có) — fail-open resurrect nút mua là sai chiều.
    if (state === 'fallback' && ssrBuyDisabled()) return;

    main.querySelectorAll('[data-purchase-skeleton]').forEach((el) => el.remove());
    main.querySelectorAll('[data-purchase-control]').forEach((el) => {
      el.classList.remove('hidden');
      el.classList.add('flex');
    });
    // Side-guide + mobile CTA: bỏ skeleton + reveal control (đồng bộ loading, tránh flash)
    main.querySelectorAll('[data-side-purchase-skeleton]').forEach((el) => el.remove());
    main.querySelectorAll('[data-side-purchase-control]').forEach((el) => { el.hidden = false; });
    const mobileCta = document.querySelector('[data-component="mobile-sticky-purchase-cta"]');
    if (mobileCta) mobileCta.hidden = false;
    // API xác nhận còn bán → gỡ notice 販売停止 SSR (metafield có thể trễ chiều
    // mở-bán-lại — không được vừa hiện nút mua vừa báo hết bán).
    document.querySelectorAll('[data-buy-disabled-notice]').forEach((el) => { el.hidden = true; });
    // ⚠️ 欠品/在庫なし KHÔNG chặn mua (state 'out' không gate nút nữa).
    // 1:1 Joomla: PDP set `form_addtocart` không hề check stock
    // (ps_product.php:8377-8394, gate chỉ USE_AS_CATALOGUE/price/attributes) và
    // nhánh đổi nút sang 通知 trong addtocart_form_new.tpl.php cần
    // `CHECK_STOCK == '1'` — config production RỖNG (virtuemart.cfg.php:108).
    // Chỉ 販売終了 (buy_enable=false, jos_vm_cart_close) mới ẩn nút — xử lý ở
    // hydrateStock bên dưới. Stock chỉ đổi text 在庫：あり/なし + ảnh placeholder.
  }

  // Swap ảnh chính sang placeholder 欠品(stockout)/完売(soldout) 1:1 Joomla
  // getImageUrlForEmpty (ps_product.php:4217-4234). Live (SSR product.available
  // untracked luôn true nên phải swap qua JS). KHÔNG miễn 予約 — Joomla swap thuần
  // theo soldout(buyEnable) > stockout(stock>0), không call site nào exempt reserve.
  function swapMainImage(kind) {
    const img = document.getElementById('pdp-main-img');
    if (!img) return;
    const src = kind === 'soldout' ? img.dataset.soldoutImg : img.dataset.stockoutImg;
    if (!src) return;
    img.src = src;
    // Link phóng to trỏ về placeholder luôn (khỏi mở ảnh gốc).
    const link = img.closest('[data-pdp-main-link]');
    if (link) link.href = src;
    // Bỏ thumbnail (Joomla sold-out branch bỏ toàn bộ thumbnail).
    document.querySelectorAll('[data-pdp-thumbs]').forEach((el) => { el.style.display = 'none'; });
  }

  // === Bundle stock DUY NHẤT của PDP (perf §B5+§C″): SKU chính + 関連商品 +
  // presents trong MỘT call /stock?include=presents. Memoized — hydrateStock và
  // hydrateRelatedBuyEnable cùng await 1 promise. Adopt request bắn sớm từ inline
  // `stock-early-fetch` (chạy lúc parse HTML) khi đúng tập SKU.
  let stockBundlePromise = null;
  function pdpMainSku() {
    const mm = document.querySelector('[data-pdp-mix-match]');
    return (mm && mm.dataset.sku) || (window.INK_PDP && window.INK_PDP.sku) || '';
  }
  function stockBundle() {
    if (stockBundlePromise) return stockBundlePromise;
    const relatedSkus = [...document.querySelectorAll('[data-related-pager] [data-related-item][data-sku]')]
      .map((el) => el.dataset.sku)
      .filter(Boolean);
    // Trần 50 SKU/call (StockController) — main luôn đứng đầu; related tràn trần
    // (hiếm) → phần dư không có data, hydrateRelatedBuyEnable coi như fail-open.
    const skus = [...new Set([pdpMainSku(), ...relatedSkus].filter(Boolean))].slice(0, 50);
    if (!skus.length) {
      stockBundlePromise = Promise.resolve(null);
      return stockBundlePromise;
    }
    const chunk = skus.join(',');
    const early = window.__inkStockEarly;
    if (early && early.skus === chunk && early.presents === true) {
      delete window.__inkStockEarly;
      stockBundlePromise = early.promise;
    } else {
      stockBundlePromise = fetch(STOCK_URL + '?skus=' + encodeURIComponent(chunk) + '&include=presents', {
        headers: authHeaders(),
        credentials: 'same-origin',
      }).then((res) => {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      });
    }
    return stockBundlePromise;
  }

  async function hydrateStock() {
    const main = document.querySelector('#singlecolumn');
    if (!main) return;
    const stockTexts = main.querySelectorAll('[data-stock-text]');

    const sku = pdpMainSku();
    if (!sku) {
      stockTexts.forEach((el) => { el.textContent = ''; });
      applyStockUI(main, 'fallback');
      return;
    }

    let stock = null;
    try {
      const json = await stockBundle();
      stock = json && json.data && json.data.items && json.data.items[sku];
      // Present áp TRƯỚC các nhánh return của stock — strip campaign độc lập với
      // trạng thái tồn kho.
      if (json && json.data) applyPresentData(json.data, sku);
    } catch (err) {
      console.warn('[pdp] stock fetch failed', err);
    }

    // buy_enable=false (checkBuyEnable ← jos_vm_cart_close, LIVE từ /stock) → ẨN HẲN add-to-cart
    // (Joomla không hiện nút, KHÔNG chỉ disable) + hiện notice. Đọc live giống stock (bảng động).
    if (stock && stock.buy_enable === false) {
      // bỏ skeleton (main + side-guide) — control giữ ẩn (KHÔNG reveal)
      main.querySelectorAll('[data-purchase-skeleton], [data-side-purchase-skeleton]').forEach((el) => el.remove());
      // ẩn control mua (SP thường + 自由選択 + side-guide) trong #singlecolumn
      main.querySelectorAll('[data-purchase-control], [data-pdp-mix-match], [data-side-purchase-control]').forEach((el) => { el.hidden = true; });
      // ẩn khối mua ở side-guide + mobile CTA (ngoài #singlecolumn)
      document.querySelectorAll('[data-pdp-stock-gate]').forEach((btn) => {
        const box = btn.closest('[data-ink-cart-item]') || btn;
        box.hidden = true;
      });
      const mobileCta = document.querySelector('[data-component="mobile-sticky-purchase-cta"]');
      if (mobileCta) mobileCta.hidden = true;
      // badge 在庫 để trống + hiện notice 販売停止 + swap ảnh sang 完売(soldout).
      // keep_image (checkChangeImage) → giữ ảnh gốc (getImageUrlForEmpty:4212).
      stockTexts.forEach((el) => { el.textContent = ''; });
      document.querySelectorAll('[data-buy-disabled-notice]').forEach((el) => { el.hidden = false; });
      if (stock.keep_image !== true) swapMainImage('soldout');
      return;
    }

    if (!stock || stock.status === 'unknown') {
      // Fail-open: bỏ skeleton + hiện control, không chặn mua
      stockTexts.forEach((el) => { el.textContent = ''; });
      applyStockUI(main, 'fallback');
      return;
    }

    const inStock = stock.status === 'in_stock';
    stockTexts.forEach((el) => { el.textContent = inStock ? '在庫：あり' : '在庫：なし'; });
    applyStockUI(main, inStock ? 'in' : 'out');
    // 欠品 (còn buy_enable) → swap ảnh sang stockout. keep_image (checkChangeImage)
    // → giữ ảnh gốc (getImageUrlForEmpty:4212, không miễn 予約).
    if (!inStock && stock.keep_image !== true) swapMainImage('stockout');
  }

  // ===== 2. 自由選択 (mix & match) =====
  function initMixMatch() {
    document.querySelectorAll('[data-pdp-mix-match]').forEach((root) => {
      const total = parseInt(root.dataset.total, 10) || 0;
      const variantId = root.dataset.variantId;
      const inputs = [...root.querySelectorAll('[data-mm-qty]')];
      const remaining = root.querySelector('[data-mm-remaining]');
      const submit = root.querySelector('[data-mm-submit]');
      if (!inputs.length || !submit) return;

      const totalValue = () => inputs.reduce((s, el) => s + (parseInt(el.value, 10) || 0), 0);
      const totalWithout = (skip) => inputs.reduce((s, el) => (el === skip ? s : s + (parseInt(el.value, 10) || 0)), 0);

      // changeRemainedNum (selected_product_addtocart_form.tpl.php:161-171):
      // còn lại > 0 hoặc tổng = 0 → nút disabled (text button, CSS disabled:opacity)
      const refresh = () => {
        const left = total - totalValue();
        if (remaining) remaining.value = String(left);
        const ok = left === 0 && totalValue() > 0;
        submit.disabled = !ok;
      };

      // confirmValue: nhập vượt quá → cap = total - sum(others)
      const confirmValue = (input) => {
        const cap = Math.max(0, total - totalWithout(input));
        if ((parseInt(input.value, 10) || 0) > cap) input.value = String(cap);
        refresh();
      };

      // Tính lại mỗi lần gõ, không đợi change — Safari + IME có thể không bắn change.
      inputs.forEach((input) => {
        input.addEventListener('input', (e) => {
          if (e.isComposing) return;
          const digits = input.value.replace(/[^\d]/g, '');
          if (digits !== input.value) input.value = digits;
          confirmValue(input);
        });
        input.addEventListener('change', () => confirmValue(input));
      });

      root.querySelectorAll('[data-mm-plus]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const input = btn.closest('.inputbox')?.querySelector('[data-mm-qty]');
          if (!input) return;
          if (total > totalValue()) {
            input.value = String((parseInt(input.value, 10) || 0) + 1);
            refresh();
          }
        });
      });
      root.querySelectorAll('[data-mm-minus]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const input = btn.closest('.inputbox')?.querySelector('[data-mm-qty]');
          if (!input) return;
          const v = parseInt(input.value, 10) || 0;
          if (v > 0) {
            input.value = String(v - 1);
            refresh();
          }
        });
      });

      // このセットを購入する数 (quantity_box_general5) — số BỘ, min 1
      const setQtyEl = root.querySelector('[data-mm-set-qty]');
      root.querySelector('[data-mm-set-dec]')?.addEventListener('click', () => {
        if (!setQtyEl) return;
        const v = parseInt(setQtyEl.textContent, 10) || 1;
        if (v > 1) setQtyEl.textContent = String(v - 1);
      });
      root.querySelector('[data-mm-set-inc]')?.addEventListener('click', () => {
        if (!setQtyEl) return;
        const v = parseInt(setQtyEl.textContent, 10) || 1;
        setQtyEl.textContent = String(v + 1);
      });

      submit.addEventListener('click', async () => {
        if (submit.disabled || !variantId) return;
        // breakdown {color: qty} — chỉ màu qty > 0 (mirror child_product_item[color])
        const breakdown = {};
        const skus = {};
        inputs.forEach((el) => {
          const q = parseInt(el.value, 10) || 0;
          if (q > 0) {
            breakdown[el.dataset.mmColor] = q;
            if (el.dataset.mmSku) skus[el.dataset.mmSku] = q;
          }
        });

        submit.disabled = true;
        const originalLabel = submit.textContent;
        submit.textContent = '追加中...';
        // quantity = このセットを購入する数 (số BỘ — quantity_box_general5)
        const setQty = setQtyEl ? Math.max(1, parseInt(setQtyEl.textContent, 10) || 1) : 1;
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: Number(variantId),
                quantity: setQty,
                properties: {
                  _mix_match_breakdown: JSON.stringify(breakdown),
                  _mix_match_skus: JSON.stringify(skus),
                  _mix_match_total: String(total),
                },
              }],
            }),
          });
          if (!res.ok) throw new Error('cart/add ' + res.status);
          document.dispatchEvent(new CustomEvent('ink:cart:updated'));
          document.dispatchEvent(new CustomEvent('ink:cart:added')); // mở modal COMMON (đồng nhất site)
          // Feedback giống cart-add.js + reset selection (mirror reload trang site cũ)
          submit.textContent = '追加しました';
          setTimeout(() => {
            submit.textContent = originalLabel;
            inputs.forEach((el) => { el.value = '0'; });
            refresh();
          }, 1500);
        } catch (err) {
          console.error('[pdp] mix-match add to cart', err);
          submit.textContent = originalLabel;
          refresh();
        }
      });

      refresh();
    });
  }

  // ===== 2b. 期間限定キャンペーン (present) — ẩn→hiện khi product có quà =====
  // Data đến từ hydrateStock (/stock?include=presents — cùng call với stock).
  // count>0 → set 「さらにN本」 + link + bỏ hidden. Fail-silent (conditional, không skeleton).
  function applyPresentData(data, sku) {
    const box = document.querySelector('[data-present-campaign]');
    if (!box) return;
    const presents = data && data.presents;
    const count = (presents && presents[sku]) || 0;
    if (count <= 0) return;
    const countEl = box.querySelector('[data-present-count]');
    if (countEl) countEl.textContent = String(count);
    const link = data.present_link;
    if (link) {
      // 2 chỗ dùng link campaign: chữ 詳細 trên banner + 「キャンペーンの詳細はこちら」 trong panel
      box.querySelectorAll('[data-present-link]').forEach((el) => {
        el.href = link;
      });
    }
    // Ảnh present (プレゼント画像) từ campaign active — override section setting nếu có.
    const img = data.present_img;
    if (img) {
      const imgEl = box.querySelector('[data-present-img]');
      if (imgEl) {
        imgEl.src = img;
        imgEl.classList.remove('hidden');
      }
    }
    box.classList.remove('hidden');
  }

  // ===== 3. 関連商品 pagination (5 sp/trang — mirror swiper page JS site cũ) =====
  // Gọi lại được nhiều lần (sau khi hydrateRelatedBuyEnable bỏ card 販売終了): abort
  // listener của lần trước + dựng lại bullets từ DOM hiện tại.
  let relatedPagerCtrl = null;
  function initRelatedPager() {
    const pager = document.querySelector('[data-related-pager]');
    if (!pager) return;
    if (relatedPagerCtrl) relatedPagerCtrl.abort();
    relatedPagerCtrl = new AbortController();
    const signal = relatedPagerCtrl.signal;

    const items = [...pager.querySelectorAll('[data-related-item]')];
    const perPage = parseInt(pager.dataset.perPage, 10) || 5;
    const pages = Math.ceil(items.length / perPage);
    const nav = pager.querySelector('[data-related-nav]');
    const bulletsWrap = pager.querySelector('[data-related-bullets]');
    if (bulletsWrap) bulletsWrap.textContent = '';
    if (!items.length || pages <= 1 || !nav) {
      // ≤1 trang → không cần nav; mọi card phải hiện (re-init sau khi bớt card)
      items.forEach((el) => { el.hidden = false; });
      if (nav) {
        nav.classList.add('hidden');
        nav.classList.remove('flex');
      }
      return;
    }

    const prevBtn = pager.querySelector('[data-related-prev]');
    const nextBtn = pager.querySelector('[data-related-next]');
    let current = 0;

    const bullets = [];
    for (let i = 0; i < pages; i++) {
      const b = document.createElement('button');
      b.type = 'button';
      b.textContent = String(i + 1);
      b.className = 'w-[28px] h-[28px] text-[13px] font-bold border border-[#cfcfcf] rounded-[3px]';
      b.addEventListener('click', () => show(i), { signal });
      bulletsWrap.appendChild(b);
      bullets.push(b);
    }

    function show(page) {
      current = Math.max(0, Math.min(pages - 1, page));
      items.forEach((el, idx) => {
        el.hidden = Math.floor(idx / perPage) !== current;
      });
      bullets.forEach((b, i) => {
        const active = i === current;
        b.classList.toggle('bg-[#f08300]', active);
        b.classList.toggle('text-white', active);
        b.classList.toggle('border-[#f08300]', active);
        b.classList.toggle('bg-white', !active);
        b.classList.toggle('text-[#999]', !active);
      });
      prevBtn.disabled = current === 0;
      nextBtn.disabled = current === pages - 1;
    }

    prevBtn.addEventListener('click', () => show(current - 1), { signal });
    nextBtn.addEventListener('click', () => show(current + 1), { signal });
    nav.classList.remove('hidden');
    nav.classList.add('flex');
    show(0);
  }

  // ===== 3b. 関連商品: loại product 販売終了 =====
  // Joomla relationProducts unset product khi !checkBuyEnable (ps_product.php:8134-8138,
  // soldout ← jos_vm_cart_close) → khối 関連商品 KHÔNG chứa sản phẩm ngừng bán.
  // Bảng cart_close động nên đọc live qua /stock (giống hydrateStock), rồi dựng lại pager.
  // ⚠️ Chỉ buy_enable gate; 在庫なし VẪN mua được (CHECK_STOCK rỗng) → không lọc theo stock.
  async function hydrateRelatedBuyEnable() {
    const pager = document.querySelector('[data-related-pager]');
    if (!pager) return;
    const items = [...pager.querySelectorAll('[data-related-item][data-sku]')];
    if (!items.length) return;
    const skus = [...new Set(items.map((el) => el.dataset.sku).filter(Boolean))];
    if (!skus.length) return;

    // Cùng bundle với hydrateStock (perf §B5) — không call /stock lần 2.
    let stocks = {};
    try {
      const json = await stockBundle();
      stocks = (json && json.data && json.data.items) || {};
    } catch (err) {
      console.warn('[pdp] related stock fetch failed', err); // fail-open: giữ nguyên card
      return;
    }

    let removed = 0;
    items.forEach((el) => {
      const st = stocks[el.dataset.sku];
      if (st && st.buy_enable === false) {
        el.remove();
        removed += 1;
      }
    });
    if (!removed) return;
    // Hết card → ẩn cả section: Joomla chỉ set cartForm khi `!empty($products)` sau
    // vòng unset (ps_product.php:8139) nên tiêu đề 関連商品 cũng không render.
    if (!pager.querySelector('[data-related-item]')) {
      const section = pager.closest('[data-page-section="related-products"]');
      if (section) section.hidden = true;
      return;
    }
    initRelatedPager();
  }

  function init() {
    // ⚠️ KHÔNG có initQty (stepper do cart-add.js contract lo) — gọi vào là init
    // crash và stock không bao giờ hydrate
    initMixMatch();
    hydrateStock();
    initRelatedPager();
    hydrateRelatedBuyEnable();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
